<app-ehe-header [auth]="true" (profileRelatedInfo)="getProfileInfo($event)"></app-ehe-header>
<div class="dashboard-wrapper general-wrapper" *ngIf="isLoaded">
	<div class="container">
		<div class="row">
			<div class="col-sm-4 d-aside">
				<div class="d-s-module welcome-panel">
					<app-welcome-panel [isMatchedMember]="isMatchedMember" [panelStatus]="panelStatus"></app-welcome-panel>
				</div>
				<ng-template [ngxPermissionsExcept]="[USER_LEVEL.HUBBELL_NOT_ELIGIBLE]">
					<ng-template [ngxPermissionsExcept]="[USER_LEVEL.CATALENT_CLIENT]" [ngxPermissionsOnly]="[MODULE_LEVEL.HM]">
						<div class="d-s-module">
							<app-health-panel [isMatchedMember]="isMatchedMember" [panelStatus]="panelStatus"></app-health-panel>
						</div>
					</ng-template>
					<div class="d-s-module">
						<app-wellness-panel [isMatchedMember]="isMatchedMember" [panelStatus]="panelStatus"></app-wellness-panel>
					</div>
				</ng-template>
				<app-footer style="display: none"></app-footer>
			</div>
			<div class="col-sm-8">
				<div class="row d-none">
					<div class="col-sm-12">
						<div class="d-filter hide-sort">
							<mat-select
								disableOptionCentering
								panelClass="custom-material-position"
								placeholder="Sort"
								(selectionChange)="sortFeeds($event)">
								<mat-option *ngFor="let timeOption of timeOptions" [value]="timeOption">
									{{ timeOption.viewValue }}
								</mat-option>
							</mat-select>
						</div>
					</div>
				</div>

				<app-feeds-panel
					[isMatchedMember]="isMatchedMember"
					[panelStatus]="panelStatus"
					[newsFeeds]="feeds"></app-feeds-panel>
			</div>
		</div>
	</div>
</div>
<app-ehe-spinner></app-ehe-spinner>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
